var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDictionary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.108 14.469H1V1h2.694c2.279 0 4.558.725 6.423 2.176l.725.518m0 0l.726-.518C13.432 1.829 15.712 1 17.99 1h2.694v4.144m-9.843-1.45v1.761m9.843 15.23L24 24m-12.122-9.739v-2.383h6.217v2.383m-3.108-2.383v6.217m-2.28 0h4.662m-2.383 4.662a7.77 7.77 0 100-15.54 7.77 7.77 0 000 15.54z",
    stroke: "#fff",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
export default SvgDictionary;